import { EventEmitter, Component, ViewEncapsulation, ViewChild, Input, Output, Injectable, ContentChild, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialog, MatSnackBar, MatSnackBarModule, MatProgressBarModule } from '@angular/material';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { isNullOrUndefined as isNullOrUndefined$1 } from 'util';
import { EMPTY, merge } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { tap, take } from 'rxjs/operators';
import { trigger, state, style, transition, animate } from '@angular/animations';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/entity/TmModalData.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TmModalData {
    /**
     * @param {?=} param
     */
    constructor(param) {
        /**
         * 彈窗表頭標題
         */
        this.title = '';
        /**
         * 彈窗內文
         */
        this.content = '';
        /**
         * 彈窗關閉按鈕標籤
         */
        this.cancelBtnLabel = 'CANCEL';
        /**
         * 彈窗開啟按鈕標籤
         */
        this.okBtnLabel = 'OK';
        /**
         * 是否顯示彈窗表頭上的關閉叉叉按鈕
         */
        this.showClose = true;
        if (!param) {
            return this;
        }
        if (typeof param.showClose === 'boolean') {
            this.showClose = param.showClose;
        }
        if (param.okBtnLabel) {
            this.okBtnLabel = param.okBtnLabel;
        }
        if (param.cancelBtnLabel) {
            this.cancelBtnLabel = param.cancelBtnLabel;
        }
        if (param.content) {
            this.content = param.content;
        }
        if (param.title) {
            this.title = param.title;
        }
        return this;
    }
}
if (false) {
    /**
     * 彈窗表頭標題
     * @type {?}
     */
    TmModalData.prototype.title;
    /**
     * 彈窗內文
     * @type {?}
     */
    TmModalData.prototype.content;
    /**
     * 彈窗關閉按鈕標籤
     * @type {?}
     */
    TmModalData.prototype.cancelBtnLabel;
    /**
     * 彈窗開啟按鈕標籤
     * @type {?}
     */
    TmModalData.prototype.okBtnLabel;
    /**
     * 是否顯示彈窗表頭上的關閉叉叉按鈕
     * @type {?}
     */
    TmModalData.prototype.showClose;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/entity/TmModalCloseReason.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
const TmModalCloseReason = {
    SUBMIT: 0,
    CLOSE: 1,
};
TmModalCloseReason[TmModalCloseReason.SUBMIT] = 'SUBMIT';
TmModalCloseReason[TmModalCloseReason.CLOSE] = 'CLOSE';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/component/tm-modal/tm-modal.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TmModalComponent {
    /**
     * @param {?} dialog
     */
    constructor(dialog) {
        this.dialog = dialog;
        this.CLOSE_REASON = TmModalCloseReason;
        // @ContentChild(TmModalHeaderComponent, {static: true}) headerTemp: TmModalHeaderComponent;
        // @ContentChild(TmModalBodyComponent, {static: true}) bodyTemp: TmModalBodyComponent;
        // @ContentChild(TmModalFooterComponent, {static: true}) footerTemp: TmModalFooterComponent;
        this._modalConfig = {
            width: '600px',
            position: { top: '5%' },
            maxHeight: '90%',
            panelClass: ['tm-modal'],
            closeOnNavigation: true,
            restoreFocus: true,
            autoFocus: true,
            data: new TmModalData({
                okBtnLabel: '確認',
                cancelBtnLabel: '取消'
            })
        };
        /**
         * 顯示於表頭的關閉叉叉按鈕語意標籤
         */
        this.closeBtnAriaLabel = 'Close';
        /**
         * 確認後關閉事件完成
         */
        this.afterConfirm = new EventEmitter();
        /**
         * 非確認關閉事件完成
         */
        this.afterCancel = new EventEmitter();
        this.isOpened = false;
    }
    /**
     * 彈窗設定
     * https://v8.material.angular.io/components/dialog/api#MatDialogConfig
     * @param {?} cnf
     * @return {?}
     */
    set modalConfig(cnf) {
        if (cnf) {
            if (cnf.panelClass && cnf.panelClass.length > 0) {
                this.panelClass = (/** @type {?} */ (cnf.panelClass));
                delete cnf.panelClass;
            }
            Object.assign(this._modalConfig, cnf);
        }
    }
    /**
     * @return {?}
     */
    get modalConfig() { return this._modalConfig; }
    /**
     * 自訂義彈窗的 css 類
     * @param {?} c
     * @return {?}
     */
    set panelClass(c) {
        if (!c || c.length === 0) {
            if (this.panelClass.length > 1) {
                ((/** @type {?} */ (this.panelClass))).splice(0, this.panelClass.length - 1);
            }
            return;
        }
        this._modalConfig.panelClass = this.panelClass.concat(c);
    }
    /**
     * @return {?}
     */
    get panelClass() { return (/** @type {?} */ (this._modalConfig.panelClass)); }
    /**
     * @return {?}
     */
    get data() { return this._modalConfig.data; }
    /**
     * 表頭標題
     * @param {?} s
     * @return {?}
     */
    set title(s) {
        if (s) {
            this.data.title = s;
        }
        else if (this.data.title) {
            this.data.title = '';
        }
    }
    /**
     * @return {?}
     */
    get title() { return this.data.title; }
    /**
     * 主內文
     * @param {?} s
     * @return {?}
     */
    set message(s) {
        if (s) {
            this.data.content = s;
        }
        else if (this.data.content) {
            this.data.content = '';
        }
    }
    /**
     * @return {?}
     */
    get message() { return this.data.content; }
    /**
     * 確認按鈕標籤
     * @param {?} s
     * @return {?}
     */
    set okBtnLabel(s) {
        if (s) {
            this.data.okBtnLabel = s;
        }
        else if (this.data.okBtnLabel) {
            this.data.okBtnLabel = '';
        }
    }
    /**
     * @return {?}
     */
    get okBtnLabel() { return this.data.okBtnLabel; }
    /**
     * 取消按鈕標籤
     * @param {?} s
     * @return {?}
     */
    set cancelBtnLabel(s) {
        if (s) {
            this.data.cancelBtnLabel = s;
        }
        else if (this.data.cancelBtnLabel) {
            this.data.cancelBtnLabel = '';
        }
    }
    /**
     * @return {?}
     */
    get cancelBtnLabel() { return this.data.cancelBtnLabel; }
    /**
     * 是否顯示表頭的關閉叉叉按鈕
     * @param {?} b
     * @return {?}
     */
    set showClose(b) {
        if (!isNullOrUndefined$1(b)) {
            this.data.showClose = b;
        }
    }
    /**
     * @return {?}
     */
    get showClose() { return this.data.showClose; }
    /**
     * @return {?}
     */
    open() {
        this.mdRef = this.dialog.open(this.modalTemp, this.modalConfig);
        this.isOpened = true;
        this.listenAfterCloseEvent();
        return this.mdRef.afterOpened();
    }
    /**
     * @protected
     * @return {?}
     */
    listenAfterCloseEvent() {
        this.mdRef.afterClosed().subscribe((/**
         * @param {?} v
         * @return {?}
         */
        v => {
            this.isOpened = false;
            switch (v) {
                case TmModalCloseReason.SUBMIT:
                    this.afterConfirm.emit();
                    break;
                case TmModalCloseReason.CLOSE:
                    this.afterCancel.emit();
                    break;
                default: // undefined, from backdrop click.
                    this.afterCancel.emit();
                    break;
            }
        }));
    }
    /**
     * @param {?=} reason
     * @return {?}
     */
    close(reason = TmModalCloseReason.CLOSE) {
        this.mdRef.close(reason);
        return this.mdRef.afterClosed();
    }
}
TmModalComponent.decorators = [
    { type: Component, args: [{
                selector: 'tm-modal',
                template: "<ng-template #modalTemp let-data>\r\n  <ng-content></ng-content>\r\n  <!-- <ng-content select=\"tm-modal-header\"></ng-content>\r\n  <ng-content select=\"tm-modal-body\"></ng-content>\r\n  <ng-content select=\"tm-modal-footer\"></ng-content> -->\r\n</ng-template>\r\n",
                encapsulation: ViewEncapsulation.None,
                exportAs: 'tmModal',
                styles: [".tm-modal .mat-dialog-container{padding:0}"]
            }] }
];
/** @nocollapse */
TmModalComponent.ctorParameters = () => [
    { type: MatDialog }
];
TmModalComponent.propDecorators = {
    modalTemp: [{ type: ViewChild, args: ['modalTemp', { static: true },] }],
    modalConfig: [{ type: Input }],
    panelClass: [{ type: Input }],
    title: [{ type: Input }],
    message: [{ type: Input }],
    okBtnLabel: [{ type: Input }],
    cancelBtnLabel: [{ type: Input }],
    showClose: [{ type: Input }],
    closeBtnAriaLabel: [{ type: Input }],
    afterConfirm: [{ type: Output }],
    afterCancel: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    TmModalComponent.prototype.CLOSE_REASON;
    /** @type {?} */
    TmModalComponent.prototype.modalTemp;
    /** @type {?} */
    TmModalComponent.prototype._modalConfig;
    /**
     * 顯示於表頭的關閉叉叉按鈕語意標籤
     * @type {?}
     */
    TmModalComponent.prototype.closeBtnAriaLabel;
    /**
     * 確認後關閉事件完成
     * @type {?}
     */
    TmModalComponent.prototype.afterConfirm;
    /**
     * 非確認關閉事件完成
     * @type {?}
     */
    TmModalComponent.prototype.afterCancel;
    /** @type {?} */
    TmModalComponent.prototype.mdRef;
    /** @type {?} */
    TmModalComponent.prototype.isOpened;
    /** @type {?} */
    TmModalComponent.prototype.dialog;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/component/info-confirm/info-confirm.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InfoConfirmComponent {
    /**
     * @param {?} dialog
     * @param {?} sanitizer
     */
    constructor(dialog, sanitizer) {
        this.dialog = dialog;
        this.sanitizer = sanitizer;
        /**
         * 表頭標題，預設為"INFO Confirm"
         */
        this.title = 'INFO Confirm';
        /**
         * 主內文，可以塞入 HTML 標記語法
         */
        this._message = '';
        /**
         * 確認按鈕標籤，預設為"確認"
         */
        this.okBtnLabel = '確認';
        /**
         * 取消按鈕標籤，預設為"取消"
         */
        this.cancelBtnLabel = '取消';
        /**
         * 自訂義彈窗的 css 類，預設為"info-confirm-modal"
         */
        this.panelClass = ['info-confirm-modal'];
        /**
         * 確認後關閉事件完成
         */
        this.afterConfirm = new EventEmitter();
        /**
         * 非確認關閉事件完成
         */
        this.afterCancel = new EventEmitter();
    }
    /**
     * 主內文，可以塞入 HTML 標記語法
     * @param {?} s
     * @return {?}
     */
    set message(s) {
        if (s) {
            this._message = s;
            this.safeMessage = this.sanitizer.bypassSecurityTrustHtml(this.message);
        }
        else if (this._message) {
            delete this._message;
            delete this.safeMessage;
        }
    }
    ;
    /**
     * 主內文，可以塞入 HTML 標記語法
     * @return {?}
     */
    get message() { return this._message; }
    /**
     * @return {?}
     */
    open() {
        if (this.modal.isOpened) {
            console.error('Coding error! Already opened, You should manually close opened dialog, or use ReusableInfoConfirmComponent');
            return EMPTY;
        }
        return this.modal.open();
    }
    /**
     * @return {?}
     */
    close() {
        return this.modal.close();
    }
}
InfoConfirmComponent.decorators = [
    { type: Component, args: [{
                selector: 'tm-info-confirm',
                template: "<tm-modal [title]=\"title\" [message]=\"message\" [okBtnLabel]=\"okBtnLabel\" [cancelBtnLabel]=\"cancelBtnLabel\"\r\n  [panelClass]=\"panelClass\" [modalConfig]=\"modalConfig\"\r\n  (afterConfirm)=\"afterConfirm.emit()\" (afterCancel)=\"afterCancel.emit()\">\r\n  <tm-modal-header></tm-modal-header>\r\n  <tm-modal-body>\r\n    <p #tmModalBody [innerHTML]=\"safeMessage\" style=\"white-space: pre-line;\"></p>\r\n  </tm-modal-body>\r\n  <tm-modal-footer></tm-modal-footer>\r\n</tm-modal>\r\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".info-confirm-modal .tm-modal-header{background:#a5b8f2}.info-confirm-modal .tm-modal-body{word-break:break-all}"]
            }] }
];
/** @nocollapse */
InfoConfirmComponent.ctorParameters = () => [
    { type: MatDialog },
    { type: DomSanitizer }
];
InfoConfirmComponent.propDecorators = {
    modal: [{ type: ViewChild, args: [TmModalComponent, { static: true },] }],
    title: [{ type: Input }],
    message: [{ type: Input }],
    okBtnLabel: [{ type: Input }],
    cancelBtnLabel: [{ type: Input }],
    panelClass: [{ type: Input }],
    modalConfig: [{ type: Input }],
    afterConfirm: [{ type: Output }],
    afterCancel: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    InfoConfirmComponent.prototype.modal;
    /**
     * 表頭標題，預設為"INFO Confirm"
     * @type {?}
     */
    InfoConfirmComponent.prototype.title;
    /**
     * 主內文，可以塞入 HTML 標記語法
     * @type {?}
     * @private
     */
    InfoConfirmComponent.prototype._message;
    /**
     * 主內文
     * @type {?}
     */
    InfoConfirmComponent.prototype.safeMessage;
    /**
     * 確認按鈕標籤，預設為"確認"
     * @type {?}
     */
    InfoConfirmComponent.prototype.okBtnLabel;
    /**
     * 取消按鈕標籤，預設為"取消"
     * @type {?}
     */
    InfoConfirmComponent.prototype.cancelBtnLabel;
    /**
     * 自訂義彈窗的 css 類，預設為"info-confirm-modal"
     * @type {?}
     */
    InfoConfirmComponent.prototype.panelClass;
    /**
     * 彈窗設定
     * https://v8.material.angular.io/components/dialog/api#MatDialogConfig
     * @type {?}
     */
    InfoConfirmComponent.prototype.modalConfig;
    /**
     * 確認後關閉事件完成
     * @type {?}
     */
    InfoConfirmComponent.prototype.afterConfirm;
    /**
     * 非確認關閉事件完成
     * @type {?}
     */
    InfoConfirmComponent.prototype.afterCancel;
    /** @type {?} */
    InfoConfirmComponent.prototype.dialog;
    /**
     * @type {?}
     * @protected
     */
    InfoConfirmComponent.prototype.sanitizer;
    /* Skipping unhandled member: ;*/
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/component/info-alert/info-alert.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InfoAlertComponent extends InfoConfirmComponent {
    constructor() {
        super(...arguments);
        /**
         * 表頭標題，預設為"INFO"
         */
        this.title = 'INFO';
        /**
         * 確認按鈕標籤
         */
        this.okBtnLabel = '';
        this.modalConfig = { role: 'alertdialog', hasBackdrop: false };
        /**
         * 自訂義彈窗的 css 類，預設為"info-alert-modal"
         */
        this.panelClass = ['info-alert-modal'];
    }
}
InfoAlertComponent.decorators = [
    { type: Component, args: [{
                selector: 'tm-info-alert',
                template: "<tm-modal [title]=\"title\" [message]=\"message\" [okBtnLabel]=\"okBtnLabel\" [cancelBtnLabel]=\"cancelBtnLabel\"\r\n  [panelClass]=\"panelClass\" [modalConfig]=\"modalConfig\"\r\n  (afterConfirm)=\"afterConfirm.emit()\" (afterCancel)=\"afterCancel.emit()\">\r\n  <tm-modal-header></tm-modal-header>\r\n  <tm-modal-body>\r\n    <p #tmModalBody [innerHTML]=\"safeMessage\" style=\"white-space: pre-line;\"></p>\r\n  </tm-modal-body>\r\n  <tm-modal-footer></tm-modal-footer>\r\n</tm-modal>\r\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".info-alert-modal .tm-modal-header{background:#ccf2a5}.info-alert-modal .tm-modal-body{word-break:break-all}"]
            }] }
];
InfoAlertComponent.propDecorators = {
    title: [{ type: Input }],
    panelClass: [{ type: Input }]
};
if (false) {
    /**
     * 表頭標題，預設為"INFO"
     * @type {?}
     */
    InfoAlertComponent.prototype.title;
    /**
     * 確認按鈕標籤
     * @type {?}
     */
    InfoAlertComponent.prototype.okBtnLabel;
    /** @type {?} */
    InfoAlertComponent.prototype.modalConfig;
    /**
     * 自訂義彈窗的 css 類，預設為"info-alert-modal"
     * @type {?}
     */
    InfoAlertComponent.prototype.panelClass;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/component/error-alert/error-alert.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ErrorAlertComponent extends InfoAlertComponent {
    constructor() {
        super(...arguments);
        /**
         * 表頭標題，預設為"ERROR"
         */
        this.title = 'ERROR';
        /**
         * 確認按鈕標籤
         */
        this.okBtnLabel = '';
        /**
         * 自訂義彈窗的 css 類，預設為"error-alert-modal"
         */
        this.panelClass = ['error-alert-modal'];
        /**
         * 是否顯示複製錯誤提示訊息到剪貼簿按鈕
         */
        this.showCopyButton = false;
        /**
         * 複製錯誤提示訊息到剪貼簿按鈕的標籤文字，預設為"Copy to clipboard"
         */
        this.copyBtnLabel = 'Copy to clipboard';
    }
    /**
     * 複製錯誤提示訊息到剪貼簿
     * @param {?} targetEl
     * @return {?}
     */
    copyTip(targetEl) {
        window.getSelection().selectAllChildren(targetEl);
        document.execCommand('Copy');
    }
}
ErrorAlertComponent.decorators = [
    { type: Component, args: [{
                selector: 'tm-error-alert',
                template: "<tm-modal [title]=\"title\" [message]=\"message\" [okBtnLabel]=\"okBtnLabel\" [cancelBtnLabel]=\"cancelBtnLabel\"\r\n  [panelClass]=\"panelClass\" [modalConfig]=\"modalConfig\"\r\n  (afterConfirm)=\"afterConfirm.emit()\" (afterCancel)=\"afterCancel.emit()\">\r\n  <tm-modal-header></tm-modal-header>\r\n  <tm-modal-body>\r\n    <div #tmModalBody>\r\n      <p [innerHTML]=\"safeMessage\" style=\"white-space: pre-line;\" #tmModalBody #tip></p>\r\n      <button type=\"button\" *ngIf=\"showCopyButton\" (click)=\"copyTip(tip)\">{{copyBtnLabel}}</button>\r\n    </div>\r\n  </tm-modal-body>\r\n  <tm-modal-footer></tm-modal-footer>\r\n</tm-modal>\r\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".error-alert-modal .tm-modal-header{background:#f2a5a5}.error-alert-modal .tm-modal-body{word-break:break-all}"]
            }] }
];
ErrorAlertComponent.propDecorators = {
    title: [{ type: Input }],
    panelClass: [{ type: Input }],
    showCopyButton: [{ type: Input }],
    copyBtnLabel: [{ type: Input }]
};
if (false) {
    /**
     * 表頭標題，預設為"ERROR"
     * @type {?}
     */
    ErrorAlertComponent.prototype.title;
    /**
     * 確認按鈕標籤
     * @type {?}
     */
    ErrorAlertComponent.prototype.okBtnLabel;
    /**
     * 自訂義彈窗的 css 類，預設為"error-alert-modal"
     * @type {?}
     */
    ErrorAlertComponent.prototype.panelClass;
    /**
     * 是否顯示複製錯誤提示訊息到剪貼簿按鈕
     * @type {?}
     */
    ErrorAlertComponent.prototype.showCopyButton;
    /**
     * 複製錯誤提示訊息到剪貼簿按鈕的標籤文字，預設為"Copy to clipboard"
     * @type {?}
     */
    ErrorAlertComponent.prototype.copyBtnLabel;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/component/indeterminate-progress-bar/indeterminate-progress-bar.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class IndeterminateProgressBarComponent {
    constructor() {
        this.isShow = false;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @return {?}
     */
    show() {
        this.isShow = true;
    }
    /**
     * @return {?}
     */
    hide() {
        this.isShow = false;
    }
}
IndeterminateProgressBarComponent.decorators = [
    { type: Component, args: [{
                selector: 'tm-indeterminate-progress-bar',
                template: "<div *ngIf=\"isShow\" class=\"indeterminate\">\r\n  <mat-progress-bar mode=\"indeterminate\"></mat-progress-bar>\r\n</div>\r\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".indeterminate{position:fixed;top:0;left:0;width:100%;z-index:9999}"]
            }] }
];
/** @nocollapse */
IndeterminateProgressBarComponent.ctorParameters = () => [];
if (false) {
    /** @type {?} */
    IndeterminateProgressBarComponent.prototype.isShow;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/global-component.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * \@techmore/global 組件的調用方法
 */
class GlobalComponentService {
    /**
     * @param {?} snackBar
     */
    constructor(snackBar) {
        this.snackBar = snackBar;
        /**
         * 進度條調用者註冊機
         */
        this.processingRegister = [];
        /**
         * 進度條是否顯示中
         */
        this.isProgessBarOpening = false;
    }
    /**
     * 跳出警告訊息彈出視窗
     * @param {?} message 訊息內容，可塞HTML字串
     * @param {?=} param title: 彈出視窗標題，若未帶入則使用預設值；afterClose 彈出視窗關閉後的回調函式
     * @return {?}
     */
    openInfoAlert(message, param) {
        this.globalCmp.openInfoAlert(message, param);
    }
    /**
     * 跳出訊息確認彈出視窗
     * @param {?} message 訊息內容，可塞HTML字串
     * @param {?=} param title: 彈出視窗標題，若未帶入則使用預設值；afterConfirm: 點擊確認按鈕後的回調涵式；afterClose 彈出視窗(不是點確認按鈕)關閉後的回調函式
     * @return {?}
     */
    openInfoConfirm(message, param) {
        this.globalCmp.openInfoConfirm(message, param);
    }
    /**
     * 跳出錯誤訊息彈出視窗
     * @param {?} message 訊息內容，可塞HTML字串
     * @param {?=} param title: 彈出視窗標題，若未帶入則使用預設值；afterClose 彈出視窗關閉後的回調函式；showCopyTip: 是否顯示複製到剪貼簿按鈕，預設為不顯示
     * @return {?}
     */
    openErrorAlert(message, param) {
        this.globalCmp.openErrorAlert(message, param);
    }
    /**
     * 顯示進度條，返還一個 uuid，關閉時需代入
     * @return {?}
     */
    openIndeterminateProgressBar() {
        /** @type {?} */
        const uuid = _uuid();
        this.processingRegister.push(uuid);
        if (!this.isProgessBarOpening) {
            this.isProgessBarOpening = true;
            this.globalCmp.openIndeterminateProgressBar();
        }
        return uuid;
    }
    /**
     * 關閉進度條顯示。帶入開啟時返還的 uuid，如果還有未告知結束的進度則進度條不關閉；不帶入 uuid 則清空所有已註冊的進度並關閉進度條
     * @param {?=} uuid
     * @return {?}
     */
    closeIndeterminateProgressBar(uuid) {
        if (!this.isProgessBarOpening) {
            return;
        }
        if (uuid) {
            /** @type {?} */
            const fidx = this.processingRegister.findIndex((/**
             * @param {?} s
             * @return {?}
             */
            s => s === uuid));
            if (fidx !== -1) {
                this.processingRegister.splice(fidx, 1);
            }
            if (!this.processingRegister.length) {
                this.isProgessBarOpening = false;
                this.globalCmp.closeIndeterminateProgressBar();
            }
        }
        else {
            this.isProgessBarOpening = false;
            this.globalCmp.closeIndeterminateProgressBar();
            this.processingRegister = [];
        }
    }
    /**
     * Opens a snackbar with a message and an optional action.
     * @param {?} message — The message to show in the snackbar.
     * @param {?=} action — The label for the snackbar action，defult is X.
     * @param {?=} config — [Additional configuration options](https://v8.material.angular.io/components/snack-bar/api#MatSnackBarConfig) for the snackbar, with default duration 1600 ms.
     * @return {?}
     */
    openSanckBar(message, action = 'X', config) {
        // this.globalCmp.openSanckBar(message, action, { duration: 1600, });
        /** @type {?} */
        const _cfg = Object.assign({ duration: 1600 }, config);
        this.snackBar.open(message, action, _cfg);
    }
    /**
     * 關閉短語回饋
     * @return {?}
     */
    closeSnackBar() {
        this.snackBar.dismiss();
    }
}
GlobalComponentService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
GlobalComponentService.ctorParameters = () => [
    { type: MatSnackBar }
];
if (false) {
    /**
     * 放置 global 組件的宿主組件，需在宿主中註冊進此屬性中
     * @type {?}
     */
    GlobalComponentService.prototype.globalCmp;
    /**
     * 進度條調用者註冊機
     * @type {?}
     */
    GlobalComponentService.prototype.processingRegister;
    /**
     * 進度條是否顯示中
     * @type {?}
     */
    GlobalComponentService.prototype.isProgessBarOpening;
    /**
     * @type {?}
     * @private
     */
    GlobalComponentService.prototype.snackBar;
}
/**
 * 產生 uuid。從 https://www.cythilya.tw/2017/03/12/uuid/ 參考
 * @return {?}
 */
function _uuid() {
    /** @type {?} */
    let d = Date.now();
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
        d += performance.now(); // use high-precision timer if available
    }
    // tslint:disable-next-line: only-arrow-functions
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (/**
     * @param {?} c
     * @return {?}
     */
    function (c) {
        // tslint:disable-next-line: no-bitwise
        /** @type {?} */
        const r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    }));
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/component/tm-modal-header/tm-modal-header.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TmModalHeaderComponent {
    /**
     * @param {?} modal
     */
    constructor(modal) {
        this.modal = modal;
    }
}
TmModalHeaderComponent.decorators = [
    { type: Component, args: [{
                selector: 'tm-modal-header',
                template: "<div class=\"tm-modal-header\">\r\n  <button *ngIf=\"modal.showClose\" attr.aria-label=\"{{modal.closeBtnAriaLabel}}\" class=\"tm-modal-close\" (click)=\"modal.close(modal.CLOSE_REASON.CLOSE)\" type=\"button\"><span aria-hidden=\"true\">\u00D7</span></button>\r\n  <ng-content #customTemp></ng-content>\r\n  <ng-container *ngIf=\"!headerTemp\">\r\n    <h1 class=\"tm-modal-title\" mat-dialog-title>{{ modal.title }}</h1>\r\n  </ng-container>\r\n</div>\r\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".mat-dialog-title.tm-modal-title{margin:0}.tm-modal-header{padding:15px;border-bottom:1px solid #e5e5e5}.tm-modal-close{float:right;font-size:2rem;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.2;-webkit-appearance:none;padding:0;cursor:pointer;background:0 0;border:0;margin-top:-2px}.tm-modal-close:focus,.tm-modal-close:hover{color:#000;text-decoration:none;cursor:pointer;opacity:.5}"]
            }] }
];
/** @nocollapse */
TmModalHeaderComponent.ctorParameters = () => [
    { type: TmModalComponent }
];
TmModalHeaderComponent.propDecorators = {
    headerTemp: [{ type: ContentChild, args: ['tmModalHeader', { static: true },] }]
};
if (false) {
    /** @type {?} */
    TmModalHeaderComponent.prototype.headerTemp;
    /** @type {?} */
    TmModalHeaderComponent.prototype.modal;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/component/tm-modal-body/tm-modal-body.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TmModalBodyComponent {
    /**
     * @param {?} modal
     */
    constructor(modal) {
        this.modal = modal;
    }
}
TmModalBodyComponent.decorators = [
    { type: Component, args: [{
                selector: 'tm-modal-body',
                template: "<div class=\"tm-modal-body\" mat-dialog-content>\r\n  <ng-content #customTemp></ng-content>\r\n  <ng-container *ngIf=\"!bodyTemp\">\r\n    <p>{{ modal.message }}</p>\r\n  </ng-container>\r\n</div>\r\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".mat-dialog-content.tm-modal-body{margin:0;padding:15px}"]
            }] }
];
/** @nocollapse */
TmModalBodyComponent.ctorParameters = () => [
    { type: TmModalComponent }
];
TmModalBodyComponent.propDecorators = {
    bodyTemp: [{ type: ContentChild, args: ['tmModalBody', { static: true },] }]
};
if (false) {
    /** @type {?} */
    TmModalBodyComponent.prototype.bodyTemp;
    /** @type {?} */
    TmModalBodyComponent.prototype.modal;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/component/tm-modal-footer/tm-modal-footer.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TmModalFooterComponent {
    /**
     * @param {?} modal
     */
    constructor(modal) {
        this.modal = modal;
    }
}
TmModalFooterComponent.decorators = [
    { type: Component, args: [{
                selector: 'tm-modal-footer',
                template: "<div class=\"tm-modal-footer\" mat-dialog-actions align=\"end\">\r\n  <ng-content #customTemp></ng-content>\r\n  <ng-container *ngIf=\"!footerTemp\">\r\n    <button *ngIf=\"modal.cancelBtnLabel\" type=\"button\" mat-stroked-button (click)=\"modal.close(modal.CLOSE_REASON.CLOSE)\">{{ modal.cancelBtnLabel }}</button>\r\n    <button *ngIf=\"modal.okBtnLabel\" type=\"button\" mat-stroked-button (click)=\"modal.close(modal.CLOSE_REASON.SUBMIT)\" cdkFocusInitial>{{ modal.okBtnLabel }}</button>\r\n  </ng-container>\r\n</div>\r\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".mat-dialog-actions.tm-modal-footer{margin-bottom:0;padding:15px}.tm-modal-footer{padding:15px;text-align:right;border-top:1px solid #e5e5e5}"]
            }] }
];
/** @nocollapse */
TmModalFooterComponent.ctorParameters = () => [
    { type: TmModalComponent }
];
TmModalFooterComponent.propDecorators = {
    footerTemp: [{ type: ContentChild, args: ['tmModalFooter', { static: true },] }]
};
if (false) {
    /** @type {?} */
    TmModalFooterComponent.prototype.footerTemp;
    /** @type {?} */
    TmModalFooterComponent.prototype.modal;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/component/reusable-info-confirm/reusable-info-confirm.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * 組件可重用，只建立一個確認窗口透過服務更改顯示內容，
 * 開啟重用會在未關閉確認窗時暫存所有接收到且未關閉的訊息，並在點選關閉後播放堆線中下一個訊息
 *
 * 所有參數綁定和事件拋出是間皆是引用自實體的訊息確認窗
 */
class ReusableInfoConfirmComponent {
    constructor() {
        /**
         * 確認後關閉事件完成
         */
        this.afterConfirm = new EventEmitter();
        /**
         * 非確認關閉事件完成
         */
        this.afterCancel = new EventEmitter();
        this.cachedInfos = [];
    }
    /**
     * 實體的訊息確認窗
     * @param {?} c
     * @return {?}
     */
    set infoConfirm(c) {
        if (c) {
            this._infoConfirm = c;
            this.setPendingDatas();
        }
    }
    /**
     * @return {?}
     */
    get infoConfirm() { return this._infoConfirm; }
    /**
     * 表頭標題
     * @param {?} t
     * @return {?}
     */
    set title(t) {
        if (this.infoConfirm) {
            this.infoConfirm.title = t;
            this._pendingTitle = undefined;
        }
        else {
            this._pendingTitle = t;
        }
    }
    /**
     * @return {?}
     */
    get title() {
        if (this.infoConfirm) {
            return this.infoConfirm.title;
        }
    }
    /**
     * 主內文
     * @param {?} m
     * @return {?}
     */
    set message(m) {
        if (this.infoConfirm) {
            this.infoConfirm.message = m;
            this._pendingMessage = undefined;
        }
        else {
            this._pendingMessage = m;
        }
    }
    /**
     * @return {?}
     */
    get message() {
        if (this.infoConfirm) {
            return this.infoConfirm.message;
        }
    }
    /**
     * 確認按鈕標籤
     * @param {?} ol
     * @return {?}
     */
    set okBtnLabel(ol) {
        if (this.infoConfirm) {
            this.infoConfirm.okBtnLabel = ol;
            this._pendingOkBtnLabel = undefined;
        }
        else {
            this._pendingOkBtnLabel = ol;
        }
    }
    /**
     * @return {?}
     */
    get okBtnLabel() {
        if (this.infoConfirm) {
            return this.infoConfirm.okBtnLabel;
        }
    }
    /**
     * 取消按鈕標籤
     * @param {?} cl
     * @return {?}
     */
    set cancelBtnLabel(cl) {
        if (this.infoConfirm) {
            this.infoConfirm.cancelBtnLabel = cl;
            this._pendingCancelBtnLabel = undefined;
        }
        else {
            this._pendingCancelBtnLabel = cl;
        }
    }
    /**
     * @return {?}
     */
    get cancelBtnLabel() {
        if (this.infoConfirm) {
            return this.infoConfirm.cancelBtnLabel;
        }
    }
    /**
     * 自訂義彈窗的 css 類
     * @param {?} pc
     * @return {?}
     */
    set panelClass(pc) {
        if (this.infoConfirm) {
            this.infoConfirm.panelClass = pc;
            this._pendingPanelClass = undefined;
        }
        else {
            this._pendingPanelClass = pc;
        }
    }
    /**
     * @return {?}
     */
    get panelClass() {
        if (this.infoConfirm) {
            return this.infoConfirm.panelClass;
        }
    }
    /**
     * 彈窗設定
     * https://v8.material.angular.io/components/dialog/api#MatDialogConfig
     * @param {?} c
     * @return {?}
     */
    set modalConfig(c) {
        if (this.infoConfirm) {
            this.infoConfirm.modalConfig = c;
            this._pendingModalConfig = undefined;
        }
        else {
            this._pendingModalConfig = c;
        }
    }
    /**
     * @return {?}
     */
    get modalConfig() {
        if (this.infoConfirm) {
            return this.infoConfirm.modalConfig;
        }
    }
    /**
     * @param {?} message
     * @param {?} param
     * @return {?}
     */
    open(message, param) {
        if (this.isSameWithLastest(message, param)) {
            return;
        }
        /** @type {?} */
        const cached = {
            message: (message),
            param: (param),
        };
        this.cachedInfos.push(cached);
        /** @type {?} */
        const cIndex = this.cachedInfos.length - 1;
        this.setInfo(cached, cIndex);
        if (!this.infoConfirm.modal.isOpened) {
            this.infoConfirm.open();
        }
    }
    /**
     * 檢查新的訊息和目前快去中最後一則訊息，是否完全一致。
     * 如果一致應該丟棄訊息
     * @private
     * @param {?} message
     * @param {?} param
     * @return {?}
     */
    isSameWithLastest(message, param) {
        if (!this.cachedInfos.length) {
            return false;
        }
        /** @type {?} */
        const lastestCached = this.cachedInfos[this.cachedInfos.length - 1];
        if (lastestCached.message !== message) {
            return false;
        }
        if (param.title !== lastestCached.param.title) {
            return false;
        }
        try {
            if (!param.afterClose && lastestCached.param.afterClose
                || param.afterClose && !lastestCached.param.afterClose
                || (param.afterClose && lastestCached.param.afterClose && param.afterClose.toString() !== lastestCached.param.afterClose.toString())) {
                return false;
            }
            if (!param.afterConfirm && lastestCached.param.afterConfirm
                || param.afterConfirm && !lastestCached.param.afterConfirm
                || (param.afterConfirm && lastestCached.param.afterConfirm && param.afterConfirm.toString() !== lastestCached.param.afterConfirm.toString())) {
                return false;
            }
        }
        catch (error) {
            return false;
        }
        return true;
    }
    /**
     * @protected
     * @param {?} cached
     * @param {?} cacheIndex
     * @return {?}
     */
    setInfo(cached, cacheIndex) {
        this.infoConfirm.message = cached.message;
        if (cached.param) {
            if (cached.param.title) {
                this.infoConfirm.title = cached.param.title;
            }
            if (this.cachedInfos.length > 1) {
                this.cachedInfos[this.cachedInfos.length - 2].closeSubc.unsubscribe();
            }
        }
        /** @type {?} */
        let closeReason = TmModalCloseReason.SUBMIT;
        cached.closeSubc = merge(this.infoConfirm.afterConfirm.pipe(tap((/**
         * @return {?}
         */
        () => { closeReason = TmModalCloseReason.SUBMIT; }))), this.infoConfirm.afterCancel.pipe(tap((/**
         * @return {?}
         */
        () => { closeReason = TmModalCloseReason.CLOSE; })))).pipe(take(1)).subscribe((/**
         * @return {?}
         */
        () => {
            if (closeReason === TmModalCloseReason.SUBMIT) {
                if (cached.param && cached.param.afterConfirm) {
                    cached.param.afterConfirm();
                }
            }
            else {
                if (cached.param && cached.param.afterClose) {
                    cached.param.afterClose();
                }
            }
            this.cachedInfos.splice(cacheIndex, 1);
            if (this.cachedInfos.length > 0) {
                /** @type {?} */
                const cIndex = this.cachedInfos.length - 1;
                /** @type {?} */
                const nextCachedAlert = this.cachedInfos[cIndex];
                this.setInfo(nextCachedAlert, cIndex);
                this.infoConfirm.open();
            }
        }));
    }
    /**
     * @protected
     * @return {?}
     */
    setPendingDatas() {
        if (this._pendingTitle) {
            this.title = this._pendingTitle;
        }
        if (this._pendingMessage) {
            this.message = this._pendingMessage;
        }
        if (this._pendingOkBtnLabel) {
            this.okBtnLabel = this._pendingOkBtnLabel;
        }
        if (this._pendingCancelBtnLabel) {
            this.cancelBtnLabel = this._pendingCancelBtnLabel;
        }
        if (this._pendingPanelClass) {
            this.panelClass = this._pendingPanelClass;
        }
        if (this._pendingModalConfig) {
            this.modalConfig = this._pendingModalConfig;
        }
    }
}
ReusableInfoConfirmComponent.decorators = [
    { type: Component, args: [{
                selector: 'tm-reusable-info-confirm',
                template: "<tm-info-confirm\r\n  (afterConfirm)=\"afterConfirm.emit()\"\r\n  (afterCancel)=\"afterCancel.emit()\">\r\n</tm-info-confirm>\r\n",
                styles: [""]
            }] }
];
ReusableInfoConfirmComponent.propDecorators = {
    infoConfirm: [{ type: ViewChild, args: [InfoConfirmComponent, { static: false },] }],
    title: [{ type: Input }],
    message: [{ type: Input }],
    okBtnLabel: [{ type: Input }],
    cancelBtnLabel: [{ type: Input }],
    panelClass: [{ type: Input }],
    modalConfig: [{ type: Input }],
    afterConfirm: [{ type: Output }],
    afterCancel: [{ type: Output }]
};
if (false) {
    /**
     * @type {?}
     * @protected
     */
    ReusableInfoConfirmComponent.prototype._infoConfirm;
    /**
     * @type {?}
     * @protected
     */
    ReusableInfoConfirmComponent.prototype._pendingTitle;
    /**
     * @type {?}
     * @protected
     */
    ReusableInfoConfirmComponent.prototype._pendingMessage;
    /**
     * @type {?}
     * @protected
     */
    ReusableInfoConfirmComponent.prototype._pendingOkBtnLabel;
    /**
     * @type {?}
     * @protected
     */
    ReusableInfoConfirmComponent.prototype._pendingCancelBtnLabel;
    /**
     * @type {?}
     * @protected
     */
    ReusableInfoConfirmComponent.prototype._pendingPanelClass;
    /**
     * @type {?}
     * @protected
     */
    ReusableInfoConfirmComponent.prototype._pendingModalConfig;
    /**
     * 確認後關閉事件完成
     * @type {?}
     */
    ReusableInfoConfirmComponent.prototype.afterConfirm;
    /**
     * 非確認關閉事件完成
     * @type {?}
     */
    ReusableInfoConfirmComponent.prototype.afterCancel;
    /** @type {?} */
    ReusableInfoConfirmComponent.prototype.cachedInfos;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/component/reusable-info-alert/reusable-info-alert.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ReusableInfoAlertComponent extends ReusableInfoConfirmComponent {
    /**
     * 實體的訊息確認窗
     * @param {?} c
     * @return {?}
     */
    set infoConfirm(c) {
        if (c) {
            this._infoConfirm = c;
            this.setPendingDatas();
        }
    }
    /**
     * @return {?}
     */
    get infoConfirm() { return (/** @type {?} */ (this._infoConfirm)); }
}
ReusableInfoAlertComponent.decorators = [
    { type: Component, args: [{
                selector: 'tm-reusable-info-alert',
                template: "<tm-info-alert\r\n  (afterConfirm)=\"afterConfirm.emit()\"\r\n  (afterCancel)=\"afterCancel.emit()\">\r\n</tm-info-alert>\r\n",
                styles: [""]
            }] }
];
ReusableInfoAlertComponent.propDecorators = {
    infoConfirm: [{ type: ViewChild, args: [InfoAlertComponent, { static: false },] }]
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/component/reusable-error-alert/reusable-error-alert.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ReusableErrorAlertComponent extends ReusableInfoConfirmComponent {
    /**
     * 實體的訊息確認窗
     * @param {?} c
     * @return {?}
     */
    set infoConfirm(c) {
        if (c) {
            this._infoConfirm = c;
            this.setPendingDatas();
        }
    }
    /**
     * @return {?}
     */
    get infoConfirm() { return (/** @type {?} */ (this._infoConfirm)); }
    /**
     * @param {?} s
     * @return {?}
     */
    set showCopyButton(s) {
        if (this.infoConfirm) {
            this.infoConfirm.showCopyButton = s;
            this._pendingShowCopyButton = undefined;
        }
        else {
            this._pendingShowCopyButton = s;
        }
    }
    /**
     * @return {?}
     */
    get showCopyButton() {
        if (this.infoConfirm) {
            return this.infoConfirm.showCopyButton;
        }
    }
    /**
     * @protected
     * @return {?}
     */
    setPendingDatas() {
        super.setPendingDatas();
        if (this._pendingShowCopyButton) {
            this.showCopyButton = this._pendingShowCopyButton;
        }
    }
    /**
     * @param {?} message
     * @param {?} param
     * @return {?}
     */
    open(message, param) {
        /** @type {?} */
        const cached = {
            message: (message),
            param: (param),
        };
        this.cachedInfos.push(cached);
        /** @type {?} */
        const cIndex = this.cachedInfos.length - 1;
        this.setInfo(cached, cIndex);
        if (!this.infoConfirm.modal.isOpened) {
            this.infoConfirm.open();
        }
    }
    /**
     * @protected
     * @param {?} cached
     * @param {?} cacheIndex
     * @return {?}
     */
    setInfo(cached, cacheIndex) {
        this.infoConfirm.message = cached.message;
        if (cached.param) {
            if (cached.param.title) {
                this.infoConfirm.title = cached.param.title;
            }
            if (cached.param.showCopyTip) {
                this.infoConfirm.showCopyButton = true;
            }
            else {
                this.infoConfirm.showCopyButton = false;
            }
            if (this.cachedInfos.length > 1) {
                this.cachedInfos[this.cachedInfos.length - 2].closeSubc.unsubscribe();
            }
        }
        /** @type {?} */
        let closeReason = TmModalCloseReason.SUBMIT;
        cached.closeSubc = merge(this.infoConfirm.afterConfirm.pipe(tap((/**
         * @return {?}
         */
        () => { closeReason = TmModalCloseReason.SUBMIT; }))), this.infoConfirm.afterCancel.pipe(tap((/**
         * @return {?}
         */
        () => { closeReason = TmModalCloseReason.CLOSE; })))).pipe(take(1)).subscribe((/**
         * @return {?}
         */
        () => {
            if (closeReason === TmModalCloseReason.SUBMIT) {
                if (cached.param && cached.param.afterConfirm) {
                    cached.param.afterConfirm();
                }
            }
            else {
                if (cached.param && cached.param.afterClose) {
                    cached.param.afterClose();
                }
            }
            this.cachedInfos.splice(cacheIndex, 1);
            if (this.cachedInfos.length > 0) {
                /** @type {?} */
                const cIndex = this.cachedInfos.length - 1;
                /** @type {?} */
                const nextCachedAlert = this.cachedInfos[cIndex];
                this.setInfo(nextCachedAlert, cIndex);
                this.infoConfirm.open();
            }
        }));
    }
}
ReusableErrorAlertComponent.decorators = [
    { type: Component, args: [{
                selector: 'tm-reusable-error-alert',
                template: "<tm-error-alert\r\n  (afterConfirm)=\"afterConfirm.emit()\"\r\n  (afterCancel)=\"afterCancel.emit()\">\r\n</tm-error-alert>\r\n",
                styles: [""]
            }] }
];
ReusableErrorAlertComponent.propDecorators = {
    infoConfirm: [{ type: ViewChild, args: [ErrorAlertComponent, { static: false },] }]
};
if (false) {
    /** @type {?} */
    ReusableErrorAlertComponent.prototype._pendingShowCopyButton;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/global.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class GlobalModule {
    /**
     * @return {?}
     */
    static forRoot() {
        return { ngModule: GlobalModule, providers: [GlobalComponentService] };
    }
}
GlobalModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    MatDialogModule,
                    MatSnackBarModule,
                    MatProgressBarModule,
                    MatButtonModule,
                ],
                declarations: [
                    TmModalComponent,
                    TmModalHeaderComponent,
                    TmModalBodyComponent,
                    TmModalFooterComponent,
                    InfoAlertComponent,
                    InfoConfirmComponent,
                    ErrorAlertComponent,
                    IndeterminateProgressBarComponent,
                    ReusableInfoConfirmComponent,
                    ReusableInfoAlertComponent,
                    ReusableErrorAlertComponent,
                ],
                exports: [
                    TmModalComponent,
                    TmModalHeaderComponent,
                    TmModalBodyComponent,
                    TmModalFooterComponent,
                    InfoAlertComponent,
                    InfoConfirmComponent,
                    ErrorAlertComponent,
                    IndeterminateProgressBarComponent,
                    ReusableInfoConfirmComponent,
                    ReusableInfoAlertComponent,
                    ReusableErrorAlertComponent,
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/IGlobalComponent.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
class IGlobalComponent {
}
if (false) {
    /**
     * @abstract
     * @param {?} message
     * @param {?=} param
     * @return {?}
     */
    IGlobalComponent.prototype.openInfoAlert = function (message, param) { };
    /**
     * @abstract
     * @param {?} message
     * @param {?=} param
     * @return {?}
     */
    IGlobalComponent.prototype.openInfoConfirm = function (message, param) { };
    /**
     * @abstract
     * @param {?} message
     * @param {?=} param
     * @return {?}
     */
    IGlobalComponent.prototype.openErrorAlert = function (message, param) { };
    /**
     * @abstract
     * @return {?}
     */
    IGlobalComponent.prototype.openIndeterminateProgressBar = function () { };
    /**
     * @abstract
     * @return {?}
     */
    IGlobalComponent.prototype.closeIndeterminateProgressBar = function () { };
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/util.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const isSupportObjectFit = (/**
 * @return {?}
 */
() => {
    return 'objectFit' in document.documentElement.style;
});
/**
 * @param {?} o
 * @return {?}
 */
function isNullOrUndefined(o) {
    return typeof o === 'undefined' || o === null;
}
/** @type {?} */
const checkIsMobile = (/**
 * @return {?}
 */
() => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/.test(window.navigator.userAgent) || checkIsIphone() || checkIsIpad();
});
/**
 * (瀏覽器端) 檢查設備是否為 iphone
 * @return {?}
 */
function checkIsIphone() {
    if (window['MSStream']) {
        return false;
    }
    if (window.navigator.platform) {
        return /iPhone/.test(window.navigator.platform);
    }
    else {
        return /iPhone/.test(window.navigator.userAgent);
    }
}
/**
 * (瀏覽器端) 檢查設備是否為 ipad|ipod
 * @return {?}
 */
function checkIsIpad() {
    if (window['MSStream']) {
        return false;
    }
    if (window.navigator.platform) {
        return /iPad|iPod/.test(window.navigator.platform) || (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);
    }
    else {
        return /iPad|iPod/.test(window.navigator.userAgent) || /Mac/.test(window.navigator.userAgent) && window.navigator.maxTouchPoints > 1;
    }
}
/**
 * (瀏覽器端) 檢查設備是否為 Mac 電腦
 * @return {?}
 */
function checkIsMacDesktop() {
    if (window['MSStream']) {
        return false;
    }
    if (window.navigator.platform) {
        return (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints <= 1);
    }
    else {
        return /Mac/.test(window.navigator.userAgent) && window.navigator.maxTouchPoints <= 1;
    }
}
/**
 * @return {?}
 */
function isIOS() {
    return checkIsIphone() || checkIsIpad() || checkIsMacDesktop();
}
/**
 * 檢查是否為觸控螢幕裝置
 * @return {?}
 */
function checkIsTouchMobile() {
    /** @type {?} */
    let hasTouchScreen = false;
    /** @type {?} */
    const navigator = window.navigator;
    if ('maxTouchPoints' in navigator) {
        hasTouchScreen = navigator.maxTouchPoints > 0;
    }
    else if ('msMaxTouchPoints' in navigator) {
        hasTouchScreen = ((/** @type {?} */ (navigator)))['msMaxTouchPoints'] > 0;
    }
    else {
        /** @type {?} */
        const mQ = window['matchMedia'] && window['matchMedia']('(pointer:coarse)');
        if (mQ && mQ.media === '(pointer:coarse)') {
            hasTouchScreen = !!mQ.matches;
        }
        else if ('orientation' in window) {
            hasTouchScreen = true; // deprecated, but good fallback
        }
        else {
            // Only as a last resort, fall back to user agent sniffing
            /** @type {?} */
            const UA = ((/** @type {?} */ (navigator))).userAgent;
            hasTouchScreen = (/\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
                /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA));
        }
    }
    return hasTouchScreen;
}
/**
 * @param {?} document
 * @param {?} renderer
 * @param {?} parentEl
 * @param {?} styleName
 * @param {?} path
 * @param {?=} crossOrigin
 * @return {?}
 */
function loadLazyCssFile(document, renderer, parentEl, styleName, path, crossOrigin = false) {
    if (document.getElementById(styleName)) {
        return;
    }
    /** @type {?} */
    const styleElement = renderer.createElement('link');
    renderer.setAttribute(styleElement, 'id', `${styleName}`);
    renderer.setAttribute(styleElement, 'href', `${path}`);
    renderer.setAttribute(styleElement, 'rel', `stylesheet`);
    if (crossOrigin) {
        renderer.setAttribute(styleElement, 'crossOrigin', `anonymous`);
        // FIXME: from moj frontend
        // renderer.setAttribute(styleElement, 'integrity', `sha256-${sha256(path)}`);
    }
    // TODO: add csp nonce
    /** @type {?} */
    const body = (/** @type {?} */ (parentEl.closest('body')));
    /** @type {?} */
    const head = (/** @type {?} */ (body.previousElementSibling));
    renderer.insertBefore(head, styleElement, head.querySelector('link[rel="canonical"]'));
}
/**
 * @param {?} document
 * @param {?} renderer
 * @param {?} scriptName
 * @param {?} path
 * @param {?=} useDefer
 * @param {?=} crossOrigin
 * @return {?}
 */
function loadLazyJsFile(document, renderer, scriptName, path, useDefer, crossOrigin = false) {
    if (document.getElementById(scriptName)) {
        return;
    }
    /** @type {?} */
    const script = renderer.createElement('script');
    renderer.setAttribute(script, 'id', `${scriptName}`);
    renderer.setAttribute(script, 'type', `text/javascript`);
    renderer.setAttribute(script, 'src', `${path}`);
    renderer.setAttribute(script, 'async', ``);
    if (useDefer) {
        renderer.setAttribute(script, 'defer', ``);
    }
    if (crossOrigin) {
        renderer.setAttribute(script, 'crossOrigin', `anonymous`);
        // FIXME: from moj frontend
        // renderer.setAttribute(script, 'integrity', `sha256-${sha256(path)}`);
    }
    // TODO: add csp nonce
    // 用 document 塞在 server 端部會有作用, 但沒關係這個在 client 端在執行就好
    // 用 parentEl.closest('body').previousSiblingsElement appendChild 也沒用 (但 insertBefore 沒試過)
    renderer.appendChild(document.head, script);
}
/**
 * @return {?}
 */
function closestPolifill() {
    if (!Element.prototype.matches) {
        Element.prototype.matches =
            ((/** @type {?} */ (Element.prototype))).msMatchesSelector ||
                Element.prototype.webkitMatchesSelector;
    }
    if (!Element.prototype.closest) {
        Element.prototype.closest = (/**
         * @param {?} s
         * @return {?}
         */
        function (s) {
            /** @type {?} */
            let el = this;
            do {
                if (typeof s === 'string' && Element.prototype.matches.call(el, s)) {
                    return el;
                }
                else if (typeof s === 'object' && el === s) {
                    return el;
                }
                el = el.parentElement || el.parentNode;
            } while (el !== null && el.nodeType === 1);
            return null;
        });
    }
}
/**
 * 可餵入 HTMLElement做目標比對的 closest 方法
 * @type {?}
 */
const closest = (/**
 * @param {?} el
 * @param {?} s
 * @return {?}
 */
(el, s) => {
    /** @type {?} */
    let target = el;
    do {
        if (typeof s === 'string') {
            if (Element.prototype.matches.call(el, s)) {
                return el;
            }
        }
        else if (s instanceof HTMLElement) {
            if (el === s) {
                return el;
            }
        }
        target = target['parentElement'] || target['parentNode'];
    } while (target !== null && target['nodeType'] && target['nodeType'] === 1);
    return null;
});
/**
 * 將表格的查詢參數轉換成查 API 用的查詢參數
 * @param {?} queryParam
 * @return {?}
 */
function transferTableParams2HttpListParams(queryParam) {
    /** @type {?} */
    let params = {};
    if (queryParam.limit) {
        params['size'] = `${queryParam.limit}`;
    }
    if (queryParam.filter) {
        params['sfilterize'] = `${queryParam.filter}`;
    }
    if (queryParam.search) {
        params['search'] = `${queryParam.search}`;
    }
    if (queryParam.limit && (queryParam.offset || queryParam.offset === 0)) {
        params['page'] = `${queryParam.offset / queryParam.limit}`;
    }
    if (queryParam.sort && queryParam.order) {
        params['sort'] = `${queryParam.sort},${queryParam.order}`;
    }
    if (queryParam.query) {
        /** @type {?} */
        const query = JSON.parse(queryParam.query);
        /** @type {?} */
        const keys = Object.keys(query);
        if (keys.length !== 0) {
            for (const k of keys) {
                if (!isNullOrUndefined(query[k])) {
                    params[k] = query[k];
                }
            }
        }
    }
    return params;
}
/**
 * 將物件中為定義的值轉成 null
 * @param {?} customSearchEntity
 * @return {?}
 */
function transferObjNullVal(customSearchEntity) {
    for (let keys = Object.keys(customSearchEntity), i = 0; i < keys.length; i++) {
        /** @type {?} */
        const key = keys[i];
        if (typeof customSearchEntity[key] === 'undefined') {
            customSearchEntity[key] = null;
        }
    }
}
/**
 * 將物件中未定義或空值移除
 * @param {?} customSearchEntity
 * @return {?}
 */
function rmObjNullorUndefinedVal(customSearchEntity) {
    for (let keys = Object.keys(customSearchEntity), i = 0; i < keys.length; i++) {
        /** @type {?} */
        const key = keys[i];
        if (customSearchEntity[key] === null || customSearchEntity[key] === undefined) {
            delete customSearchEntity[key];
        }
    }
}
/**
 * 打亂陣列排序
 * @param {?} data
 * @return {?}
 */
function randomData(data) {
    // tslint:disable-next-line: only-arrow-functions
    data.sort((/**
     * @return {?}
     */
    function () {
        return (0.5 - Math.random());
    }));
    return data;
}
/**
 * @param {?} url
 * @return {?}
 */
function removeUrlQueryParam(url) {
    /** @type {?} */
    let queryIndex = url.indexOf('?');
    if (queryIndex === -1) {
        queryIndex = url.indexOf(';');
    }
    if (queryIndex > 0) {
        url = url.substring(0, queryIndex);
    }
    return url;
}
/**
 *
 * @param {?} url location.href
 * @return {?} 轉成物件的查詢參數, ex: {param1: '', param2: ''}
 */
function parseQueryPqrams(url) {
    /** @type {?} */
    let queryParamSatrtIndex = url.indexOf('?');
    /** @type {?} */
    const queryParam = {};
    if (queryParamSatrtIndex !== -1) {
        /** @type {?} */
        const urlQueryParam = url.slice(queryParamSatrtIndex + 1, url.length);
        urlQueryParam.split('&').forEach((/**
         * @param {?} qps
         * @return {?}
         */
        qps => {
            /** @type {?} */
            const a = qps.split('=');
            queryParam[a[0]] = a[1];
        }));
        url = url.replace('?' + urlQueryParam, '');
    }
    queryParamSatrtIndex = url.indexOf(';');
    if (queryParamSatrtIndex !== -1) {
        /** @type {?} */
        const urlQueryParam = url.slice(queryParamSatrtIndex + 1, url.length);
        urlQueryParam.split('&').forEach((/**
         * @param {?} qps
         * @return {?}
         */
        qps => {
            /** @type {?} */
            const a = qps.split('=');
            queryParam[a[0]] = a[1];
        }));
    }
    return queryParam;
}
/**
 * 解析 JWT token
 * @param {?} accessToken
 * @return {?}
 */
function parseJWTtoken(accessToken) {
    /** @type {?} */
    const base64Url = accessToken.split('.')[1];
    /** @type {?} */
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    switch (base64.length % 4) {
        case 0: break;
        case 2:
            base64 += '==';
            break;
        case 3:
            base64 += '=';
            break;
        default: break;
    }
    /** @type {?} */
    const jwtPayloadStr = decodeURIComponent(escape(atob(base64)));
    return JSON.parse(jwtPayloadStr);
}
/** @type {?} */
const fadeInOutAnimation = trigger('fadeInOut', [
    state('true', style({
        visibility: 'inherit',
        opacity: 1
    })),
    state('false', style({
        visibility: 'hidden',
        opacity: 0
    })),
    transition('* => *', animate('0.5s'))
]);
/**
 * 在 server side 和 client side 做路徑轉導
 * @param {?} isBrowser
 * @param {?} router
 * @param {?} response
 * @param {?} path
 * @return {?}
 */
function navigateCrossPlatform(isBrowser, router, response, path) {
    if (isBrowser) {
        return router.navigateByUrl(path.join('/'));
    }
    else {
        response.redirect(301, path.join('/'));
        response.finished = true;
        response.end();
        return response;
    }
}
/**
 * 轉換貨幣字符成數字
 * @param {?} currency
 * @return {?}
 */
function currencyToNum(currency) {
    return Number(currency.toString().replace(/[^0-9.-]+/g, ''));
}
/**
 * 轉換數字成貨幣字符
 * @param {?} num
 * @return {?}
 */
function numCurrency(num) {
    return Intl.NumberFormat('en-US').format(num);
}
/**
 * 回傳範圍內的數值陣列
 * @param {?} end
 * @param {?=} start
 * @param {?=} step
 * @param {?=} includeEnd
 * @return {?}
 */
function range(end, start = 0, step = 1, includeEnd = true) {
    /** @type {?} */
    const size = (end - start) / step + (includeEnd ? 1 : 0);
    return Array.from(Array(size)).map((/**
     * @param {?} _
     * @param {?} i
     * @return {?}
     */
    (_, i) => start + i * step));
}
/**
 * Function that returns element rectangle & position (width, height, top, left)
 * @param {?} element - Element which position & rectangle are returned
 * @return {?}
 */
function getRectangle(element) {
    /** @type {?} */
    const width = Math.max(element.offsetWidth, element.clientWidth, element.scrollWidth);
    /** @type {?} */
    const height = Math.max(element.offsetHeight, element.clientHeight, element.scrollHeight);
    /** @type {?} */
    let top = 0;
    /** @type {?} */
    let left = 0;
    do {
        top += element.offsetTop || 0;
        left += element.offsetLeft || 0;
        element = (/** @type {?} */ (element.offsetParent));
    } while (element);
    return { top, left, width, height };
}

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: techmore-global.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { ErrorAlertComponent, GlobalComponentService, GlobalModule, IGlobalComponent, IndeterminateProgressBarComponent, InfoAlertComponent, InfoConfirmComponent, ReusableErrorAlertComponent, ReusableInfoAlertComponent, ReusableInfoConfirmComponent, TmModalBodyComponent, TmModalCloseReason, TmModalComponent, TmModalData, TmModalFooterComponent, TmModalHeaderComponent, checkIsIpad, checkIsIphone, checkIsMacDesktop, checkIsMobile, checkIsTouchMobile, closest, closestPolifill, currencyToNum, fadeInOutAnimation, getRectangle, isIOS, isNullOrUndefined, isSupportObjectFit, loadLazyCssFile, loadLazyJsFile, navigateCrossPlatform, numCurrency, parseJWTtoken, parseQueryPqrams, randomData, range, removeUrlQueryParam, rmObjNullorUndefinedVal, transferObjNullVal, transferTableParams2HttpListParams };
//# sourceMappingURL=techmore-global.js.map
